/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ValidateEmployeeNumberRequestModel } from '../../models/validate-employee-number-request-model';
import { ValidateEmployeeNumberResponseModel } from '../../models/validate-employee-number-response-model';

export interface HealthWithHeartValidateEmployeeNumberPost$Params {
      body?: ValidateEmployeeNumberRequestModel
}

export function healthWithHeartValidateEmployeeNumberPost(http: HttpClient, rootUrl: string, params?: HealthWithHeartValidateEmployeeNumberPost$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<ValidateEmployeeNumberResponseModel>> {
  const rb = new RequestBuilder(rootUrl, healthWithHeartValidateEmployeeNumberPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<ValidateEmployeeNumberResponseModel>;
    })
  );
}

healthWithHeartValidateEmployeeNumberPost.PATH = '/HealthWithHeart/ValidateEmployeeNumber';
